import React, { useEffect, useState } from 'react';
import './TempNav.css';

function TempNav() {
    const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    useEffect(()=>{
        var FirstActive = document.getElementsByClassName("About");
        Array.from(FirstActive).forEach(element=>{
            element.classList.add("Active");
        })
        },[]   
    );

    function CategoryActivator(event) {
        var NavPropts = document.getElementsByClassName('Nav');
        
        // HTMLCollection'ı diziye çevir ve sınıfı kaldır
        Array.from(NavPropts).forEach(element => {
            if (element.classList.contains("Active")) {
                element.classList.remove("Active");
            }
        });

        // Tıklanan elemente "Active" sınıfını ekle
        event.target.classList.add("Active");
    }

    return (
        <nav id='HomeNavBar'>
            <button onClick={CategoryActivator} className='Nav About Active'>{isEnglish ? "About" : "Hakkımda"}</button>
            <button onClick={CategoryActivator} className='Nav Resume'>{isEnglish ? "Resume" : "Özgeçmiş"}</button>
            <button onClick={CategoryActivator} className='Nav Portfolio'>{isEnglish ? "Portfolio" : "Portfolyo"}</button>
            <button onClick={CategoryActivator} className='Nav Contact'>{isEnglish ? "Contact" : "İletişim"}</button>
        </nav>
    );
}

export default TempNav;
